const faq = {
  target: '#tour_faq',
  content: `
    <p>You can easily find the tour again via the help button in the future.</p>
    <p>You can also click <strong><a href="https://youtu.be/oXFd0br5eSQ" class="secondary--text" target="_blank">here</a></strong> to watch the instructional video.</p>
  `,
  params: {
    placement: 'left',
    buttonStop: 'Ok',
  },
};

export const TOURS = {
  welcome_pre_employment: {
    name: 'welcome_pre_employment',
    steps: [
      {
        target: '#tour_create_a_risk_profile',
        content: `
          Great! Simply click <strong>"Create a Risk Profile"</strong> to set up the job role. You will be guided through the process. 
        `,
        params: {
          enableScrolling: false,
          highlight: true,
          buttonSkip: 'End Tour',
        },
      },
      {
        target: '#tour_make_a_booking',
        content: `
          Once the Risk Profile is set up, simply click <strong>"Make a booking"</strong> to get started!.
        `,
        params: {
          enableScrolling: false,
          highlight: true,
          buttonSkip: 'End Tour',
        },
      },
      {
        ...faq,
      },
    ],
  },
  welcome_ghc: {
    name: 'welcome_ghc',
    steps: [
      {
        target: '#tour_faq',
        content: `
          Before you start sending out health checks, please check out the free marketing pack for your organisation to use in promotion of a health check program via the help button. 
        `,
        params: {
          enableScrolling: false,
          buttonSkip: 'End Tour',
        },
      },
      {
        target: '#tour_make_a_ghc_booking',
        content: `
          Once you are ready, simply click <strong>"Make a booking"</strong> to book a general health check to get started. You will be guided through the process.
        `,
        params: {
          enableScrolling: false,
          highlight: true,
          buttonSkip: 'End Tour',
        },
      },
      {
        ...faq,
      },
    ],
  },
  faq: {
    name: 'faq',
    steps: [
      {
        ...faq,
      },
    ],
  },
};
